import React from 'react'
import './_divider.scss'

function Divicer() {
  return <hr className="divider" />
}

export default Divicer
